import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { GestorRepository } from '@app/domain/ports/tpv/gestor.repository';
import {
  GestorAssignResult,
  GestorServicesResult,
  GestorUpdateResult,
} from '@app/domain/models/tpv/gestor.model';
import {
  AssignGestorRequest,
  AssignTpvGestorRequest,
  UpdateGestorRequest,
} from '@app/data/dtos/tpv/gestor.dto';

/** Mock de gestores para desarrollo sin backend (tpvUseMocks). */
@Injectable()
export class GestorMockDataSource extends GestorRepository {
  override assign(request: AssignGestorRequest): Observable<GestorAssignResult> {
    const tpv = request as AssignTpvGestorRequest;
    const level = tpv.id_company != null ? 'company' : 'father';
    return of<GestorAssignResult>({
      idGestor: 9001,
      polipayAccount: request.polipay_account,
      service: (request as AssignTpvGestorRequest).service ?? 'TPV',
      level,
      idCompany: tpv.id_company ?? null,
      sufijo: tpv.sufijo ?? null,
      entity: 462,
      entityType: 'mock',
      role: { id: request.rol_id, name: 'Mock Rol' },
      consumedProduct: { id: 555, servicio: 'TPV', provider: 'MEMPHIS' },
    }).pipe(delay(400));
  }

  override listServices(
    polipayAccount: string,
    includeInactive = false,
  ): Observable<GestorServicesResult> {
    return of<GestorServicesResult>({
      polipayAccount,
      includeInactive,
      count: 2,
      services: [
        {
          idGestor: 12,
          idConsumedProduct: 30,
          isActive: true,
          role: { id: 4, name: 'Operador' },
          entityType: 'mock',
          provider: 'STP',
          service: 'SPEI',
        },
        {
          idGestor: 13,
          idConsumedProduct: 31,
          isActive: true,
          role: { id: 2, name: 'Administrador' },
          entityType: 'mock',
          provider: 'MEMPHIS',
          service: 'TPV',
        },
      ],
    }).pipe(delay(400));
  }

  override update(request: UpdateGestorRequest): Observable<GestorUpdateResult> {
    return of<GestorUpdateResult>({
      idGestor: request.id_gestor,
      isActive: request.is_active ?? true,
      role: request.id_rol ? { id: request.id_rol, name: 'Mock Rol' } : undefined,
    }).pipe(delay(400));
  }
}
